<template>
  <el-dialog :title="dataForm.id ? 'Edit Template' : 'Add Template'" :close-on-click-modal="false" :visible.sync="visible" width="1000px" top="3vh">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" autocomplete="off" label-position="top">
      <el-row :gutter="10">
        <el-col :span="24">
          <copy-from :dataForm="dataForm" :options="invoiceTemplateList" :labelFormatter="item => item.templateName" @copyFromTrigger="copyFromTrigger" />
        </el-col>
        <el-col :span="12">
          <el-form-item label="Supplier" prop="supplierId">
            <el-select v-model="dataForm.supplierId" filterable clearable placeholder="Supplier" class="wdb100" @change="supplierChange">
              <el-option v-for="item in supplierList" :key="`supplier-${item.id}`" :label="item.companyName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Country" prop="country">
            <el-select v-model="dataForm.country" filterable clearable placeholder="Country" class="wdb100" @change="countryChange">
              <el-option v-for="item in countryList" :key="item.value" :label="item.title" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="Template Name" prop="templateName">
            <el-input v-model="dataForm.templateName" clearable placeholder="e.g. SG-EStar-Standard"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Invoice Type" prop="invoiceType">
            <el-select v-model="dataForm.invoiceType" clearable placeholder="Invoice Type" class="wdb100">
              <el-option v-for="item in invoiceTypeList" :key="item.value" :label="item.title" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Language" prop="languageOption">
            <el-select v-model="dataForm.languageOption" clearable placeholder="Language" class="wdb100">
              <el-option v-for="item in languageList" :key="item.value" :label="item.title" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="Bank Accounts" prop="bankAccountIds">
            <template v-if="dataForm.supplierId">
              <template v-if="supplierBankAccountList.length > 0">
                <select-bank-account v-model="dataForm.bankAccountIds" :supplierBankAccountList="supplierBankAccountList" />
              </template>
              <div class="notSelectTipBg" v-else>
                <span>No bank accounts for this supplier.</span>
              </div>
            </template>
            <div class="notSelectTipBg" v-else>
              <span>Select supplier first</span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import CopyFrom from "@/components/CopyFrom";
import SelectBankAccount from "@/components/SelectBankAccount";
import { mapState } from "vuex";
export default {
  props: {
    invoiceTemplateList: {
      type: Array,
      default: () => [],
    },
    supplierList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    CopyFrom,
    SelectBankAccount,
  },
  data() {
    return {
      visible: false,
      dataForm: {
        id: null,
        supplierId: null,
        country: null,
        templateName: "",
        invoiceType: null,
        languageOption: "",
        bankAccountIds: [],
      },
      dataRule: {
        supplierId: [{ required: true, message: "please select", trigger: "submit" }],
        country: [{ required: true, message: "please select", trigger: "submit" }],
        templateName: [{ required: true, message: "please enter", trigger: "submit" }],
        invoiceType: [{ required: true, message: "please select", trigger: "submit" }],
        languageOption: [{ required: true, message: "please select", trigger: "submit" }],
        bankAccountIds: [{ type: "array", required: true, message: "please select", trigger: "submit" }],
      },
      languageList: [],
      checkedBankAccountList: [],
      supplierBankAccountList: [],
      submitLoading: false,
    };
  },
  computed: {
    ...mapState("constant", ["countryList", "invoiceTypeList"]),
  },
  methods: {
    async init(data) {
      this.visible = true;
      this.submitLoading = false;
      this.languageList = [];
      this.checkedBankAccountList = [];
      this.supplierBankAccountList = [];
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      if (data) {
        // 设置languageList
        this.countryChange(data.country);
        // 设置supplierBankAccountList
        const supplierId = data?.supplier?.id || "";
        this.supplierChange(supplierId);
        const bankAccountIds = data?.bankAccountList?.map(item => item.id) || [];
        this.dataForm = {
          id: data.id,
          supplierId,
          country: data.country,
          templateName: data.templateName,
          invoiceType: data.invoiceType,
          languageOption: data.languageOption,
          bankAccountIds,
        };
      } else {
        this.$set(this.dataForm, "id", null);
      }
    },
    // 表单提交
    async formSubmitRequest() {
      const params = {
        ...this.dataForm,
      };
      if (params.id) {
        return await this.$http.put(`/admin/invoiceTemplate/${params.id}`, params);
      } else {
        return await this.$http.post("/admin/invoiceTemplate", params);
      }
    },
    dataFormSubmit() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          this.submitLoading = true;
          this.formSubmitRequest()
            .then(res => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            })
            .catch(err => {
              this.submitLoading = false;
            });
        }
      });
    },
    // 接收复制完成的数据
    copyFromTrigger(originalData, newDataForm) {
      // 设置languageList
      this.countryChange(originalData.country);
      // 设置supplierBankAccountList
      const supplierId = originalData?.supplier?.id || "";
      this.supplierChange(supplierId);
      // 更新
      newDataForm.supplierId = supplierId;
      newDataForm.bankAccountIds = originalData?.bankAccountList?.map(item => item.id) || [];
      this.dataForm = newDataForm;
    },
    // 选择country时，动态设置Language中的选项
    countryChange(val) {
      const target = this.countryList.find(item => item.value === val);
      this.languageList = target?.supportLanguageList || [];
      this.$set(this.dataForm, "languageOption", "");
    },
    // supplier选中时
    supplierChange(id) {
      const target = this.supplierList.find(ele => ele.id === id);
      this.supplierBankAccountList = target?.supplierBankAccountList || [];
    },
  },
};
</script>

<style lang="scss" scoped></style>
